import { endpoints } from './../../../environments/environment';
import { UserList } from './models/user-list';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { EditUserData } from './models/edit-user-data';
import * as moment from 'moment';
import { Auth } from '../../autentication/Auth';
import { AccountNumberPipe } from '../../shared/account-number.pipe';

@Injectable()
export class UserAdminService {
	userList: Array<UserList>;
	editUserData: EditUserData;

	constructor(private http: HttpClient) { }

	getUsers(): Observable<UserList[]> {
		return this.http.get( endpoints.consultants ).pipe(map((data: any) => {


				if (data.Sucesso && data.Retorno !== undefined ) {
					this.userList = data.Retorno.map(item => {
						const list = new UserList();

						list.userCpf = item.CPF;
						list.userName = item.NomeCompleto;
						list.userEditable = item.Editavel;

						return list;
					});
				}

			return this.userList;
		}));
	}

	deleteUser(cpf: number): Observable<any> {

		return this.http.delete( endpoints.consultants + cpf, {} );
	}

	editUser(cpf: number) {
		return this.http.get( endpoints.consultants + cpf ).pipe(map((data: any) => {
			const item = data.Retorno;
			const list = new EditUserData;

				if (data.Sucesso && data.Retorno !== undefined ) {

					list.userCpf = item.CPF;
					list.userName = item.NomeCompleto;
					list.userEditable = item.Editavel;
					list.userCellphone = item.Celular;
					list.userEmail = item.Email;
					list.userBrazilian = (item.Brasileiro) ? 'brazilian' : 'other';
					list.userUF = item.UF;
					list.userNaturalness = item.Naturalidade;
					list.userMotherName = item.NomeMae;
					list.userBirthDate = moment(item.DataNascimento).format('DD/MM/YYYY');
					list.userRG = item.RG;
					list.userGender = item.Sexo;

				}


			return list;
		}));
	}

	editUserSend(cpf: number) {
		return this.http.get( endpoints.consultants + cpf ).pipe(map((data: any) => {

			return data.Retorno;
		}));
	}

	sendUserData(frmUser, frmCpf, update) {

		const cpf = frmCpf.cpf.replace(/\D/g, '');

		let brazilian = false;
		if (frmUser.nationality === 'brazilian') {
			brazilian = true;
		}

		const date = frmUser.birthDate.split('/').reverse().join('-');
		const motherName = frmUser.motherName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		const city = frmUser.city.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

		const accNumPipe = new AccountNumberPipe();

		const userData = {
			CodAgencia: Auth.getInstance().getUser().agency,
			NroConta: accNumPipe.transform(Auth.getInstance().getUser().accountNumber),
			CPF: cpf,
			NomeCompleto: frmUser.name.toUpperCase(),
			Celular: frmUser.cellphone.replace(/\D/g, ''),
			Email: frmUser.emails.email,
			Brasileiro: brazilian,
			UF: frmUser.state,
			Naturalidade: city,
			NomeMae: motherName,
			DataNascimento: date,
			RG: frmUser.rg.replace(/\D/g, ''),
			Sexo: frmUser.gender,
			Editavel: true
		};

		if (update) {
			return this.http.put(endpoints.consultants + cpf, userData );
		} else {
			return this.http.post(endpoints.consultants, userData );
		}
	}

	sendUserDataEnd(frmUser) {
		return this.http.post(endpoints.consultants, frmUser );
	}

	getStates(): any[] {

		return [
			{
				 "ID":"1",
				 "initials":"AC",
				 "name":"Acre"
			},
			{
				 "ID":"2",
				 "initials":"AL",
				 "name":"Alagoas"
			},
			{
				 "ID":"3",
				 "initials":"AM",
				 "name":"Amazonas"
			},
			{
				 "ID":"4",
				 "initials":"AP",
				 "name":"Amapá"
			},
			{
				 "ID":"5",
				 "initials":"BA",
				 "name":"Bahia"
			},
			{
				 "ID":"6",
				 "initials":"CE",
				 "name":"Ceará"
			},
			{
				 "ID":"7",
				 "initials":"DF",
				 "name":"Distrito Federal"
			},
			{
				 "ID":"8",
				 "initials":"ES",
				 "name":"Espírito Santo"
			},
			{
				 "ID":"9",
				 "initials":"GO",
				 "name":"Goiás"
			},
			{
				 "ID":"10",
				 "initials":"MA",
				 "name":"Maranhão"
			},
			{
				 "ID":"11",
				 "initials":"MG",
				 "name":"Minas Gerais"
			},
			{
				 "ID":"12",
				 "initials":"MS",
				 "name":"Mato Grosso do Sul"
			},
			{
				 "ID":"13",
				 "initials":"MT",
				 "name":"Mato Grosso"
			},
			{
				 "ID":"14",
				 "initials":"PA",
				 "name":"Pará"
			},
			{
				 "ID":"15",
				 "initials":"PB",
				 "name":"Paraíba"
			},
			{
				 "ID":"16",
				 "initials":"PE",
				 "name":"Pernambuco"
			},
			{
				 "ID":"17",
				 "initials":"PI",
				 "name":"Piauí"
			},
			{
				 "ID":"18",
				 "initials":"PR",
				 "name":"Paraná"
			},
			{
				 "ID":"19",
				 "initials":"RJ",
				 "name":"Rio de Janeiro"
			},
			{
				 "ID":"20",
				 "initials":"RN",
				 "name":"Rio Grande do Norte"
			},
			{
				 "ID":"21",
				 "initials":"RO",
				 "name":"Rondônia"
			},
			{
				 "ID":"22",
				 "initials":"RR",
				 "name":"Roraima"
			},
			{
				 "ID":"23",
				 "initials":"RS",
				 "name":"Rio Grande do Sul"
			},
			{
				 "ID":"24",
				 "initials":"SC",
				 "name":"Santa Catarina"
			},
			{
				 "ID":"25",
				 "initials":"SE",
				 "name":"Sergipe"
			},
			{
				 "ID":"26",
				 "initials":"SP",
				 "name":"São Paulo"
			},
			{
				 "ID":"27",
				 "initials":"TO",
				 "name":"Tocantins"
			}
		];
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/user-admin.service.ts